import {t, Trans} from '@lingui/macro';
import React, {FC} from 'react';

import {TextBox} from '../../../../../libs/shared/ui/src/components/boxedInputs/textBox';
import {TooltipCoordinator} from '../../../../../libs/shared/ui/src/components/tooltips/tooltipCoordinator';
import {VisualSizesEnum} from '../../../../../libs/shared/ui/src/styles/commonStyles';
import {useUserTheme} from '../../../../../libs/shared/ui/src/theme/userThemeProvider';
import {useLocalize} from '../../../../../srcCommon/internationalization/internationalizationContext';
import {PreviewerEditorStateActions} from '../../../editors/previewerEditor/usePreviewerEditorState';
import {AtomLine} from '../../../rules/ruleEditor/expressions/atomLine';

/*
 * Props.
 */

interface PreviewerDomainInputProps {
  domain: string;
  onUpdate: PreviewerEditorStateActions['onUpdateDomain'];
  isReadOnly: boolean;
}

/*
 * Component.
 */

export const PreviewerDomainInput: FC<PreviewerDomainInputProps> = (props) => {
  const theme = useUserTheme();
  const {domain, onUpdate, isReadOnly} = props;
  const localize = useLocalize();

  return (
    <TextBox
      value={domain}
      onChange={onUpdate}
      size={VisualSizesEnum.LARGE}
      noMargin
      label={
        <AtomLine>
          <span>
            <Trans id="previewer-editor-domain-label">URL domain</Trans>
          </span>
          <TooltipCoordinator
            iconColor={theme.greys.shade70}
            render={() => (
              <Trans id="previewer-editor-domain-tooltip">
                This preview will be applied to all URLs belonging to this domain.
              </Trans>
            )}
          />
        </AtomLine>
      }
      placeholder={localize(t('previewer-editor-domain-placeholder')`backoffice.company.com`)}
      isDisabled={isReadOnly}
      shouldAutoFocus
    />
  );
};
